import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCalendarEvent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={16}
    fill="none"
    viewBox="0 0 14 16"
    {...props}
  >
    <path
      fill="#5C78C7"
      d="M9.005 13a1.94 1.94 0 0 1-1.422-.579A1.92 1.92 0 0 1 7 11.005q0-.838.579-1.422A1.92 1.92 0 0 1 8.995 9q.838 0 1.422.579.583.578.583 1.416t-.579 1.422A1.92 1.92 0 0 1 9.005 13M1.5 16q-.62 0-1.06-.448A1.45 1.45 0 0 1 0 14.5v-11q0-.604.44-1.052A1.43 1.43 0 0 1 1.5 2H3V.75q0-.319.214-.534A.72.72 0 0 1 3.746 0q.316 0 .535.216A.72.72 0 0 1 4.5.75V2h5V.75q0-.319.214-.534A.72.72 0 0 1 10.246 0q.316 0 .535.216A.72.72 0 0 1 11 .75V2h1.5q.619 0 1.06.448.44.449.44 1.052v11q0 .605-.44 1.052A1.43 1.43 0 0 1 12.5 16zm0-1.5h11V7h-11zm0-9h11v-2h-11z"
    />
  </svg>
);
export default SvgCalendarEvent;
